import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
// import 'rxjs/add/operator/map';
// import 'rxjs/add/observable/of';
// import 'rxjs/add/operator/do';
// import 'rxjs/add/operator/delay';
import { of } from "rxjs";
import { map } from "rxjs/operators";
import { WebStorage } from "../utility/web.storage";
import { AppConfig } from "../config/app.config";
import { HttpClient } from "../utility/http.client";
@Injectable()
export class AuthService {
  isLoggedIn = false;

  constructor(
    private http: HttpClient,
    private storage: WebStorage
  ) {}

  checkLogin(): Observable<any> {
    return this.http.get("/users/checkUser", []);
  }

  login(data: any): Observable<any> {
    return this.http.post("/users/login", data).pipe(
      map((res: any) => {
        let body = res;
        let accessData = [];
        if (body.code == 200) {
          accessData.push(body.data.sideModules);
          this.storage.localStore("token", body.data.token);
          this.storage.setUserDetails(body.data.user);
          this.storage.localStore("role", body.data.user.role);
          this.storage.localStore("sideModule", JSON.stringify(accessData));
        }
        return body;
      })
    );
  }

  logout(): Observable<any> {
    this.storage.clear("token");
    this.storage.clear("user");
    this.storage.clear("role");
    this.isLoggedIn = false;
    return of({ status: true });
  }
}
